import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {showMessage} from '../../actions/messageBox'

class AddNewForm extends Component {
    constructor(props) {
        super(props)

        this.onAdd = this.onAdd.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleKeyPress = this.handleKeyPress.bind(this)
        this.inputRef = null



        this.initialState = {
            keyToAdd: '',
            error: '',
            id: null
        }

        this.state = this.initialState
    }

    onAddTransform(e, addType) {

        let input = document.querySelector("#integrationTransformations .JSONForm .integrationTransformationsJSONStr label[for='" + addType +"']")

        if (input) {

            this.props.dispatch(showMessage({
                    type: "error",
                    title: "Warning",
                    message: input.innerText + " has already been added.",
                    timeout: 5000,
                    buttonArray: ["OK"],
                    onClick: (buttonIndex) =>{
                          
                    }
                })   
            ) 
        }  else {

            let value = addType

            let initialVal = this.state

            let result = this.props.onAdd(value, 'editor', this.props.parentKey, addType + 1)

            if ((result !== undefined && result.success)) {

                this.setState({ ...this.initialState }, () => {
                    this.inputRef.focus()
                })
            } else {
                if (result && result.error) {
                    this.setState({ error: result.error }, () => {
                        this.inputRef.focus()
                    })
                } else {
                    this.setState({ error: "There was an error adding the field" }, () => {
                        this.inputRef.focus()
                    })
                }
            }
        }

    }

    onAdd(e, addType) {
        
        let validateResult = { error: "" }
        if (this.props.validation && typeof this.props.validation === "function") {
            validateResult = this.props.validation(this.state.keyToAdd)
        }

        if (this.state.keyToAdd === '') {
            //do not add an empty key
            this.setState({ error: 'Field cannot be empty' }, () => {
                this.inputRef.focus()
            })
            return
        }

        if (validateResult && validateResult.error) {
            this.setState({ error: validateResult.error }, () => {
                this.inputRef.focus()
            })
            return
        }

        let result = this.props.onAdd(this.state.keyToAdd, addType, this.props.parentKey, this.props.buttonId)
        //console.log('META TESTING RESULT',result)
        if ((result !== undefined && result.success)) {

            this.setState({ ...this.initialState }, () => {
                this.inputRef.focus()
            })
        } else {
            if (result && result.error) {
                this.setState({ error: result.error }, () => {
                    this.inputRef.focus()
                })
            } else {
                this.setState({ error: "There was an error adding the field" }, () => {
                    this.inputRef.focus()
                })
            }
        }
    }

    onAddPredefined(e, addType) {

        switch (addType) {

            case 'filters':

                setTimeout(() => {
                  
                    this.props.onAdd("create_filters", "text", this.props.parentKey, "option_filters1")
                }, "100");

                setTimeout(() => {
                  
                    this.props.onAdd("update_filters", "text", this.props.parentKey, "option_filters2")
                }, "100");

                setTimeout(() => {
                  
                    this.props.onAdd("limit", "text", this.props.parentKey, "option_filters3")
                }, "100");

                setTimeout(() => {
                  
                    this.props.onAdd("enable_responder", "boolean", this.props.parentKey, "option_filters4")
                }, "100");     

                setTimeout(() => {
                  
                    this.props.onAdd("response_count", "text", this.props.parentKey, "option_filters5")
                }, "100");  

                setTimeout(() => {
                  
                    this.props.onAdd("on_error_continue", "boolean", this.props.parentKey, "option_filters6")
                }, "100");   

                setTimeout(() => {
                  
                    this.props.onAdd("on_update_extract", "boolean", this.props.parentKey, "option_filters7")
                }, "100");   

                break;

            case 'last_modified':

                setTimeout(() => {
                  
                    this.props.onAdd("last_modified_key", "text", this.props.parentKey, "option_filters8")
                }, "100");

                setTimeout(() => {
                  
                    this.props.onAdd("last_modified_type", "text", this.props.parentKey, "option_filters9")
                }, "100");

                setTimeout(() => {
                  
                    this.props.onAdd("last_modified_value", "object", this.props.parentKey, "option_filters10")
                }, "100");

                 setTimeout(() => {
                  
                    this.props.onAdd("create", "text", "last_modified_value", "option_filters11")
                }, "100");

                setTimeout(() => {
                  
                    this.props.onAdd("update", "text", "last_modified_value", "option_filters12")
                }, "100");

                setTimeout(() => {
                  
                    this.props.onAdd("on_error_set", "boolean", "last_modified_value", "option_filters13")
                }, "100");  

                break;

            case 'publish':

                setTimeout(() => {
                  
                    this.props.onAdd("publish_count", "text", this.props.parentKey, "option_filters14")
                }, "100");

                setTimeout(() => {
                  
                    this.props.onAdd("publish", "object", this.props.parentKey, "option_filters15")
                }, "100");

                 setTimeout(() => {
                  
                    this.props.onAdd("enable_compare", "boolean", "publish", "option_filters16")
                }, "100");

                setTimeout(() => {
                  
                    this.props.onAdd("enable_audit", "boolean", "publish", "option_filters17")
                }, "100");

                break;

            case 'retry_error':

                setTimeout(() => {
                  
                    this.props.onAdd("retry_error", "object", this.props.parentKey, "option_filters18")
                }, "100");

                 setTimeout(() => {
                  
                    this.props.onAdd("enabled", "boolean", "retry_error", "option_filters19")
                }, "100");

                setTimeout(() => {
                  
                    this.props.onAdd("days_ago", "text", "retry_error", "option_filters20")
                }, "100");

                setTimeout(() => {
                  
                    this.props.onAdd("force_extract", "boolean", "retry_error", "option_filters21")
                }, "100");

                break;

            case 'responder_composite':

                setTimeout(() => {
                  
                    this.props.onAdd("enabled_response_checking", "boolean", this.props.parentKey, "option_filters6")
                }, "100");   

                setTimeout(() => {
                  
                    this.props.onAdd("on_update_response", "boolean", this.props.parentKey, "option_filters7")
                }, "100");  

                break;
        }
            
    }

    handleChange(e) {

        let keyToAdd = e.target.value
        let validateResult = { error: "" }

        let lowerKeyToAdd = keyToAdd.replace(/ /g, '_').toLowerCase()
     
        let content = document.getElementById("add-new-main")        

        if (content) {

            let grayoutPass = true

            let integOptionsTab = document.getElementById("integrationOptions-tab")

            if (integOptionsTab) {

                if (integOptionsTab.className.includes("active")) {

                    grayoutPass = false
                }
            }

            let kbButtons = content.getElementsByTagName("button")

            if (kbButtons) {

                for (let i=0; i < kbButtons.length; i++) {

                   let val = kbButtons[i].innerText || kbButtons[i].textContent          

                   if(
                        grayoutPass && (
                            lowerKeyToAdd.includes("password") ||
                            lowerKeyToAdd.includes("key") ||
                            lowerKeyToAdd.includes("token") ||
                            lowerKeyToAdd.includes("secret")
                        )
                    ) {
                       if(val.toLowerCase() == 'password') {

                            kbButtons[i].disabled=false
                       } else if (val.id != 'add-new-main-button') {

                            if (kbButtons[i].id != 'add-new-main-button') {

                                kbButtons[i].disabled=true
                            }
                       }
                    } else {

                        kbButtons[i].disabled=false
                    }
                }
            }
        }

        if (this.props.validation && typeof this.props.validation === "function") {
            validateResult = this.props.validation(keyToAdd)
        }

        if (validateResult && validateResult.error === "") {            
            this.setState({ keyToAdd: e.target.value, error: '' })
        } else {
            this.setState({ error: validateResult.error }, () => {
                this.inputRef.focus()
            })
        }
    }

    handleKeyPress(e) {
        if (e.charCode === 13) {
            e.preventDefault()
            e.stopPropagation()
            this.onAdd(e, 'value')
        }
    }

    renderForm() {

        if (this.props.allowedTypes && this.props.allowedTypes.includes("Transform")) {
            return (
                <div className="container custom-alignment-css">
                    <input type="hidden" className={"form-control" + (this.state.error ? " is-invalid" : "")} placeholder={this.props.placeholder || "Key"}
                        value={this.state.keyToAdd}
                        onChange={this.handleChange}
                        onKeyPress={this.handleKeyPress}
                        ref={node => this.inputRef = node} />
                    <div className="invalid-feedback">
                        {this.state.error}
                    </div>
                    <div className="datatype-btn-group btn-group">
                        <button type="button" className="btn btn-primary btn-sm pt-2 pb-2" onClick={e => this.onAddTransform(e, 'before_extract')} >Before Extract</button>
                        <button type="button" className="btn btn-primary btn-sm" onClick={e => this.onAddTransform(e, 'after_extract')} >After Extract</button>
                        <button type="button" className="btn btn-primary btn-sm" onClick={e => this.onAddTransform(e, 'before_transform')} >Before Transform</button>
                        <button type="button" className="btn btn-primary btn-sm" onClick={e => this.onAddTransform(e, 'after_transform')} >After Transform</button>
                        <button type="button" className="btn btn-primary btn-sm" onClick={e => this.onAddTransform(e, 'before_publish')} >Before Publish</button>
                        <button type="button" className="btn btn-primary btn-sm" onClick={e => this.onAddTransform(e, 'after_publish')} >After Publish</button>
                        <button type="button" className="btn btn-primary btn-sm" onClick={e => this.onAddTransform(e, 'before_response')} >Before Response</button>
                        <button type="button" className="btn btn-primary btn-sm" onClick={e => this.onAddTransform(e, 'after_response')} >After Response</button>
                    </div>
               </div>
            )
        } else {

            return (
                <div className="container">
                    { this.props.allowedTypes[0] != "UserAdmin" && 
                    <input type="text" className={"form-control" + (this.state.error ? " is-invalid" : "")} placeholder={this.props.placeholder || "Key"}
                        value={this.state.keyToAdd}
                        onChange={this.handleChange}
                        onKeyPress={this.handleKeyPress}
                        ref={node => this.inputRef = node} />
                    }
                    <div className="invalid-feedback">
                        {this.state.error}
                    </div>
                    {/*console.log('this.props.allowedTypessadasd',this.props.allowedTypes)*/}
                    <div className="datatype-btn-group btn-group pt-2">
                        {((this.props.allowedTypes && this.props.allowedTypes.includes("E-Id")) /* || !this.props.allowedTypes || this.props.allowedTypes.length === 0 */) &&
                            <button type="button" className="btn btn-primary btn-sm" onClick={e => this.onAdd(e, 'e-id')} >E-ID</button>}
                        {((this.props.allowedTypes && this.props.allowedTypes.includes("P-Id")) /* || !this.props.allowedTypes || this.props.allowedTypes.length === 0 */) &&
                            <button type="button" className="btn btn-primary btn-sm" onClick={e => this.onAdd(e, 'p-id')} >P-ID</button>}
                        {((this.props.allowedTypes && this.props.allowedTypes.includes("S-Id")) /* || !this.props.allowedTypes || this.props.allowedTypes.length === 0 */) &&
                            <button type="button" className="btn btn-primary btn-sm" onClick={e => this.onAdd(e, 's-id')} >S-ID</button>}
                        {((this.props.allowedTypes && this.props.allowedTypes.includes("F-Id")) /* || !this.props.allowedTypes || this.props.allowedTypes.length === 0 */) &&
                            <button type="button" className="btn btn-primary btn-sm" onClick={e => this.onAdd(e, 'f-id')} >F-ID</button>}
                        {((this.props.allowedTypes && this.props.allowedTypes.includes("Value")) /* || !this.props.allowedTypes || this.props.allowedTypes.length === 0 */) &&
                            <button type="button" className="btn btn-primary btn-sm" onClick={e => this.onAdd(e, 'value')} >Value</button>}
                        {((this.props.allowedTypes && this.props.allowedTypes.includes("Boolean")) /* || !this.props.allowedTypes || this.props.allowedTypes.length === 0 */) &&
                            <button type="button" className="btn btn-primary btn-sm" onClick={e => this.onAdd(e, 'boolean')} >Boolean</button>}
                        {((this.props.allowedTypes && this.props.allowedTypes.includes("Percent")) /* || !this.props.allowedTypes || this.props.allowedTypes.length === 0 */) &&
                            <button type="button" className="btn btn-primary btn-sm" onClick={e => this.onAdd(e, 'percent')} >Percent</button>}
                        {((this.props.allowedTypes && this.props.allowedTypes.includes("Text")) || !this.props.allowedTypes || this.props.allowedTypes.length === 0) &&
                            <button type="button" className="btn btn-primary btn-sm" onClick={e => this.onAdd(e, 'text')} >Text</button>}
                         {((this.props.allowedTypes && this.props.allowedTypes.includes("TextArea")) || !this.props.allowedTypes || this.props.allowedTypes.length === 0) &&
                            <button type="button" className="btn btn-primary btn-sm" onClick={e => this.onAdd(e, 'textArea')} >TextArea</button>}
                        {((this.props.allowedTypes && this.props.allowedTypes.includes("Password")) || !this.props.allowedTypes || this.props.allowedTypes.length === 0) &&
                            <button type="button" className="btn btn-primary btn-sm" onClick={e => this.onAdd(e, 'password')} >Password</button>}
                        {(this.props.allowedTypes && this.props.allowedTypes.includes("Time") ) &&
                            <button type="button" className="btn btn-primary btn-sm" onClick={e => this.onAdd(e, 'time')} >Time</button>}
                        {(this.props.allowedTypes && this.props.allowedTypes.includes("Date")) &&
                            <button type="button" className="btn btn-primary btn-sm" onClick={e => this.onAdd(e, 'date')} >Date</button>}
                        {(this.props.allowedTypes && this.props.allowedTypes.includes("DateTime")) &&
                            <button type="button" className="btn btn-primary btn-sm" onClick={e => this.onAdd(e, 'datetime')} >DateTime</button>}
                        {((this.props.allowedTypes && this.props.allowedTypes.includes("List"))) &&
                        <button type="button" className="btn btn-primary btn-sm" onClick={e => this.onAdd(e, 'list')} >List</button>}
                        {((this.props.allowedTypes && this.props.allowedTypes.includes("Object")) || !this.props.allowedTypes || this.props.allowedTypes.length === 0) &&
                            <button type="button" className="btn btn-primary btn-sm" onClick={e => this.onAdd(e, 'object')} >Object</button>}
                        {((this.props.allowedTypes && this.props.allowedTypes.includes("Array")) || !this.props.allowedTypes || this.props.allowedTypes.length === 0) &&
                            <button type="button" className="btn btn-primary btn-sm" onClick={e => this.onAdd(e, 'array')} >Array</button>}
                        {((this.props.allowedTypes && this.props.allowedTypes.includes("Meta")) || !this.props.allowedTypes || this.props.allowedTypes.length === 0) &&
                            <button type="button" className="btn btn-primary btn-sm" onClick={e => this.onAdd(e, 'meta')} >Meta</button>}
                        {((this.props.allowedTypes && this.props.allowedTypes.includes("Editor")) || !this.props.allowedTypes || this.props.allowedTypes.length === 0) &&
                        <button type="button" className="btn btn-primary btn-sm" onClick={e => this.onAdd(e, 'editor')} >Editor</button>}
                    </div>
                    { this.props.formName == 'integrationOptionsJSONStr' && this.props.parentKey == '' && this.props.allowedTypes[0] != "UserAdmin" && 
                    <hr />
                    }   
                    { this.props.formName == 'integrationOptionsJSONStr' && this.props.parentKey == '' && this.props.allowedTypes[0] != "UserAdmin" && 
                    <span>Pre-defined Properties</span>
                    }                    
                    { this.props.formName == 'integrationOptionsJSONStr' && this.props.parentKey == '' && this.props.allowedTypes[0] != "UserAdmin" && 
                        <div className="datatype-btn-group btn-group pt-2">
                            <button type="button" className="btn btn-primary btn-yellow btn-width-100 btn-sm pt-2 pb-2" onClick={e => this.onAddPredefined(e, 'filters')} >Filters</button>
                            <button type="button" className="btn btn-primary btn-yellow btn-width-100 btn-sm pt-2 pb-2" onClick={e => this.onAddPredefined(e, 'last_modified')} >Last Modified</button>
                            <button type="button" className="btn btn-primary btn-yellow btn-width-100 pt-2 pb-2" onClick={e => this.onAddPredefined(e, 'publish')} >Publish</button>
                            
                        </div> 
                    }
                    { this.props.formName == 'integrationOptionsJSONStr' && this.props.parentKey == '' && this.props.allowedTypes[0] != "UserAdmin" &&                    
                        <div className="datatype-btn-group btn-group pt-2">
                            <button type="button" className="btn btn-primary btn-yellow btn-width-100 pt-2 pb-2" onClick={e => this.onAddPredefined(e, 'retry_error')} >Retry Error</button>
                            <button type="button" className="btn btn-primary btn-sm btn-yellow pt-2 pb-2" onClick={e => this.onAddPredefined(e, 'responder_composite')} >Responder Composite</button>
                        </div>
                    }                   
                </div>
            )
        }

    }

    render() {
        if (this.props.type === 'object') {
            return (
                <div className={`AddNewForm btn-group ${this.props.menuClasses && Array.isArray(this.props.menuClasses) ? this.props.menuClasses.join(" ") : ""}`} id={this.props.id}>
                    { this.props.allowedTypes[0] != "UserAdmin" && 
                    <button type="button" id={this.props.id + "-button"} {...this.props.dropdownProps} disabled={this.props.disabled} className={`btn btn-sm btn-primary dropdown-toggle ${this.props.buttonClasses && Array.isArray(this.props.buttonClasses) ? this.props.buttonClasses.join(" ") : ""}`} data-toggle="dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        {this.props.buttonText} &nbsp;<i className="fa fa-plus fa-fd"></i>
                    </button>
                    }
                    <div className={`dropdown-menu ${this.props.id}`} aria-labelledby={this.props.id + "-button"} >
                        {this.renderForm()}
                    </div>
                </div>
            )
        } else {
            // Arrays behavior should not be able to add manually, 
            // instead, duplicate the first object To enforce consistency
            return null
        }
    }
}

AddNewForm.propTypes = {
    parentKey: PropTypes.string,
    id: PropTypes.string,
    onAdd: PropTypes.func,
    allowedTypes: PropTypes.arrayOf(PropTypes.string),
    validation: PropTypes.func,
    buttonId: PropTypes.string,
}

export default AddNewForm




// WEBPACK FOOTER //
// ./src/components/utilities/AddNewForm.js